import React from 'react'
import * as PropTypes from 'prop-types'
import { FormControlLabel } from '@material-ui/core'
import withStyles from '@material-ui/core/styles/withStyles'
import { ButtonLink } from 'components'
import NxtCheckbox from 'components/nxt_checkbox/View'
import styles from './View.Style'

const CheckboxItem = props => {
  const { 
    classes, 
    linkName, 
    item, 
    navigateTo, 
    onCheckboxClick, 
    name,
    isChecked, 
  } = props
  return (
    <FormControlLabel
      className={classes.container}
      classes={{ root: classes.marginLeft || '' }}
      key={item.id}
      control={
        <NxtCheckbox 
          value={`${item.id}`} 
          onChange={onCheckboxClick} 
          name={name} 
          isChecked={isChecked}
        />
      }
      label={
        <div className={navigateTo ? classes.radioLabelWithLink : classes.radioLabel}>
          {item.name}
          {navigateTo && (
            <ButtonLink onLinkClick={() => navigateTo(item.id)}>{linkName}</ButtonLink>
          )}
        </div>
      }
      labelPlacement="end"
    />
  )
}

CheckboxItem.defaultProps = {
  navigateTo: null,
  linkName: '',
  name: '',
  isChecked: false,
}

CheckboxItem.propTypes = {
  classes: PropTypes.shape({
    marginLeft: PropTypes.string,
    radioLabelWithLink: PropTypes.string,
    radioLabel: PropTypes.string,
  }).isRequired,
  navigateTo: PropTypes.func,
  item: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  linkName: PropTypes.string,
  onCheckboxClick: PropTypes.func.isRequired,
  name: PropTypes.string,
  isChecked: PropTypes.bool,
}

export default withStyles(styles)(CheckboxItem)
